import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import commonStyles from 'styles/common.pcss';
import { Button, Status } from 'components';

import BeautyCtn from '../BeautyCtn';
import styles from './styles.pcss';

const cx = classNames.bind({ ...commonStyles, ...styles });

export const Authenticated = ({ isCompact, isLight, ctn, buttonText, onClick }) => (
  <div className={cx('form', { compact: isCompact, light: isLight })}>
    <BeautyCtn ctn={ctn} className={cx('marb-xs')} />
    <div className={cx('statusButton')}>
      <Button className={cx('button', 'auth')} onClick={onClick}>
        {buttonText}
      </Button>
    </div>
  </div>
);

Authenticated.propTypes = {
  isCompact: PropTypes.bool,
  isLight: PropTypes.bool,
  ctn: PropTypes.string,
  buttonText: PropTypes.string,
  onClick: PropTypes.func,
};

export const Error = ({ ctn, text, onReset }) => (
  <div className={cx('form')}>
    <BeautyCtn ctn={ctn} onReset={onReset} className={cx('marb-xs')} />
    <Status isError>
      <div dangerouslySetInnerHTML={{ __html: text }} />
      {/* eslint-disable-line react/no-danger */}
    </Status>
  </div>
);

Error.propTypes = {
  ctn: PropTypes.string,
  text: PropTypes.string,
  onReset: PropTypes.func,
};
